import propTypes from 'prop-types';

export const residencePropTypesData = propTypes.shape(
  {
    uuid: propTypes.string,
    title: propTypes.string,
    description: propTypes.string,
    feeData: propTypes.object,
    buildingGroupingName: propTypes.string,
    levelName: propTypes.string,
    residents: propTypes.array,
    statusUuid: propTypes.string,
    statusName: propTypes.string,
    svgId: propTypes.string,
  },
);
